export default __webpack_public_path__ + "static/media/flower-design.61868a8e.svg";